fx.ns("filters", class LayoutPrintFilter extends fx.Filter {

	constructor(creation)
	{
        super();
        this.creation = creation;
    }

    get area()
    {
        return this._area;
    }

    set area(val)
    {
        this._area = val
        
        this._changed = true;
        this.trigger("updated");;
    }

    
	exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];


        let areaShape = "square";
        if (this.area)
        {
            if (this.area.realWidth > this.area.realHeight)
                areaShape = "landscape";
            else
            if (this.area.realWidth < this.area.realHeight)
                areaShape = "portrait";
        
            for (let i = 0; i < this.rawData.length; i++)
            {
                let layout = this.rawData.getItemAt(i);
                
                if (layout.shape == areaShape)
                    this.transformedData.push( layout );

            }
        }

		return this.transformedData;
	}	

});